import React from 'react';

// components
import CrossIcon from '../../icons/CrossIcon';

const ModalDialog = ({ header, visible, onHide, children, onSubmit, additionalClasses = [], width = 620 }) => {
    const classes = ['ModalDialog', ...additionalClasses];
    const dialogRef = React.useRef(null);

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onHide();
        }
    };

    React.useEffect(() => {
        const handleKeyDown = (e) => {
            // Handle Escape key to close modal
            if (e.key === 'Escape' && visible) {
                onHide();
                return;
            }

            // Handle Enter key for form submission
            if (e.key === 'Enter') {
                // Allow Enter to create new lines in textareas
                if (e.target.tagName === 'TEXTAREA') {
                    return;
                }

                // Don't submit when a picker popup (datepicker calendar) is open
                if (e.target.closest('.rs-picker-popup')) {
                    return;
                }

                if (onSubmit) {
                    onSubmit();
                }

                // Check if Enter was pressed in a form input
                /*const form = e.target.closest('form');
                console.log('form', form)
                if (form) {
                    const submitButton = form.querySelector('button[type="submit"]');
                    // Prevent submission if submit button is disabled
                    console.log('disabled?', submitButton?.disabled)
                    if (submitButton?.disabled) {
                        e.preventDefault();
                    } else {
                        form.submit();
                    }
                    // Otherwise, allow native form submission to proceed
                }*/
            }
        };

        if (visible) {
            document.addEventListener('keydown', handleKeyDown);
            // Prevent body scroll when modal is open
            document.body.style.overflow = 'hidden';
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.body.style.overflow = 'unset';
        };
    }, [visible, onHide]);

    // Handle dialog show/hide using native methods
    React.useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        if (visible) {
            dialog.showModal();
        } else {
            dialog.close();
        }
    }, [visible]);

    if (!visible) return null;

    return (
        <dialog
            ref={dialogRef}
            className={classes.join(' ')}
            style={{
                '--modal-max-width': `${parseInt(width)}px`
            }}
            onClick={handleBackdropClick}
        >
            <div className="ModalDialog__inner">
                <div className="ModalDialog__header">
                    <span className="ModalDialog__title">{header}</span>
                    <button
                        onClick={onHide}
                        className="ModalDialog__closeIcon"
                        aria-label="Close modal">
                        <CrossIcon/>
                    </button>
                </div>
                <div className="ModalDialog__body">
                    {children}
                </div>
            </div>
        </dialog>
    );
};

export default ModalDialog;